var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Arrow: right"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M1.77635684e-15,8 L17.0857557,8","stroke":"currentcolor","strokeWidth":"2","key":0}),React.createElement("polyline",{"stroke":"currentcolor","strokeWidth":"2","points":"10.0159715 1 17.7367428 8 10.0159715 15","key":1})])]);
}

ArrowRight.defaultProps = {"viewBox":"0 0 20 16","version":"1.1"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
